import { render, staticRenderFns } from "./TradeTransferActions.vue?vue&type=template&id=3e47ecf2&scoped=true&"
import script from "./TradeTransferActions.vue?vue&type=script&lang=js&"
export * from "./TradeTransferActions.vue?vue&type=script&lang=js&"
import style0 from "./TradeTransferActions.vue?vue&type=style&index=0&id=3e47ecf2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e47ecf2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/elopez/repos/FacturaIzzi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e47ecf2')) {
      api.createRecord('3e47ecf2', component.options)
    } else {
      api.reload('3e47ecf2', component.options)
    }
    module.hot.accept("./TradeTransferActions.vue?vue&type=template&id=3e47ecf2&scoped=true&", function () {
      api.rerender('3e47ecf2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Invoices/History/TradeTransferActions.vue"
export default component.exports